import { blinkConstants } from '@thoughtspot/blink-constants';
import { getTitle, getTrueEffectiveAggregateType, } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { isAscendingSort, isSorted } from '../../core/chart-model-utils';
import { getName } from '../../core/column-name-util';
import { ColumnAggregationType } from '../../types';
const SUPPORTED_AGGREGATIONS = new Set([
    ColumnAggregationType.Sum,
    ColumnAggregationType.Max,
    ColumnAggregationType.Min,
    ColumnAggregationType.Average,
]);
export function sortMethod(prev, next) {
    let a = prev.value;
    let b = next.value;
    a = _.isNaN(Number(a)) ? a : Number.parseFloat(a);
    b = _.isNaN(Number(b)) ? b : Number.parseFloat(b);
    if (_.isNumber(a) && _.isNumber(b)) {
        return a - b;
    }
    if (_.isString(a) && _.isString(b)) {
        return a.localeCompare(b);
    }
    if (_.isNumber(a)) {
        return -1;
    }
    return 1;
}
export function rowColFormatter(vizCol, value, isPercent = false, noShorten = true, isDouble) {
    if (_.isUndefined(value)) {
        return '';
    }
    const formattedVal = vizCol.getDataFormatter()(value, {
        isPercent: isPercent || vizCol.isPercentColumn(),
        isDouble: isDouble || vizCol.isDoubleColumn(),
        noShorten,
    });
    return String(formattedVal);
}
export function _summaryRowColFormatter(vizCol, formattedValue, aggrType) {
    if (!aggrType) {
        return formattedValue;
    }
    const trueAgg = getTrueEffectiveAggregateType(vizCol);
    if (SUPPORTED_AGGREGATIONS.has(trueAgg)) {
        return `${getTitle(vizCol) ||
            getName(vizCol, false)} : ${formattedValue}`;
    }
    return `${getTitle(vizCol) || getName(vizCol, true)} : ${formattedValue}`;
}
export function getSortOrder(chartModel, vizCol) {
    if (!isSorted(chartModel, vizCol)) {
        return null;
    }
    return isAscendingSort(chartModel, vizCol)
        ? blinkConstants.pivotTable.ascendingSort
        : blinkConstants.pivotTable.descendingSort;
}
//# sourceMappingURL=dx-table-util.js.map